import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

const appInsightsReactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
    connectionString: import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING,
    extensions: [appInsightsReactPlugin],
    enableAutoRouteTracking: true,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: false,
    enableResponseHeaderTracking: false,
    enableAjaxPerfTracking: true,
    disableFetchTracking: false,
    autoTrackPageVisitTime: true,
  },
});

if (import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING) {
  appInsights.loadAppInsights();
}

export { appInsightsReactPlugin, appInsights };

/**
 * Generic custom-event tracker shared across all pages. Delegates to the
 * configured AppInsights instance and never throws — telemetry must never
 * break the UI. Event names are free-form strings (use a `<feature>_<action>`
 * convention, e.g. `pdm_export`).
 */
export const trackEvent = (
  name: string,
  properties?: Record<string, string | number>,
): void => {
  try {
    appInsights.trackEvent({ name }, properties);
  } catch {
    // Telemetry must never break the UI.
  }
};

